import createReducer from 'Lib/createReducer';

export const OPEN_RIGHT_SIDE_PANEL = 'OPEN_RIGHT_SIDE_PANEL';
export const CLOSE_RIGHT_SIDE_PANEL = 'CLOSE_RIGHT_SIDE_PANEL';


export const openRightSidePanel = bug => {
  return {
    type: OPEN_RIGHT_SIDE_PANEL,
    data: bug
  };
};
export const closeRightSidePanel = () => {
  return {
    type: CLOSE_RIGHT_SIDE_PANEL
  };
};


const initialState = {
  right: {
    toc: false,
    search: false,
    filter: false
  },

  left: {
    toc: false,
    search: false
  }
};

export default createReducer(initialState, {
  [OPEN_RIGHT_SIDE_PANEL]: (state, action) => {
    const bug = action.data;

    return { ...state, right: { [bug]: true } };
  },

  [CLOSE_RIGHT_SIDE_PANEL]: (state, action) => {
    return { ...state, right: { toc: false, search: false , filter: false} };
  }
});
